const DAYS = [
  {
    date: "09 月 04 日",
    entries: [
      { tag: "高能动态", who: "临界点", title: "结束三个月隐身，发布两条指向性内容", digest: "配文一句「该轮到我了」被截取放大，评论量三小时破五万。", t: "22:40" },
      { tag: "素材翻译", who: "回声室", title: "旧录音被二次翻译，指向被重新解读", digest: "原句断章被补齐语境后反噬，围观转向讨论「断章」本身。", t: "19:15" },
      { tag: "榜单一览", who: "万花筒", title: "连续第七周进入提名前十，未见明显波动", digest: "素材碎片化问题仍未解决，观察者认为其或长期陪跑。", t: "11:02" },
    ],
  },
  {
    date: "09 月 03 日",
    entries: [
      { tag: "旧账复盘", who: "深水区", title: "数份「旧账底稿」被逐一翻译上线", digest: "其中一条涉及金额与时间线被网友逐帧比对，变量快速累积。", t: "23:30" },
      { tag: "热度预警", who: "逆风者", title: "评论区第三次高呼「这也能翻」", digest: "翻盘叙事第三次被唱衰，反而再次拉高当日提及量峰值。", t: "16:48" },
    ],
  },
  {
    date: "09 月 02 日",
    entries: [
      { tag: "盘口异动", who: "风向标", title: "热评三连后热度见顶回落", digest: "自我造浪质疑发酵，部分早期支持者开始「倒戈观望」。", t: "21:05" },
      { tag: "提名窗口", who: "编辑室", title: "下一位人选提名窗口正式开启", digest: "本刊开放第七期提名线索征集，首日收到候选建议逾两千条。", t: "09:00" },
    ],
  },
];

export default function Dynamics() {
  return (
    <section id="feed" className="border-t border-[#e4d9c6] bg-[#f1e9da]">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[280px_1fr]">
          {/* left rail */}
          <div className="lg:sticky lg:top-24 lg:self-start">
            <p className="text-xs font-semibold tracking-[0.25em] text-[#b03a2e] uppercase">
              Race Timeline
            </p>
            <h2 className="font-display mt-2 text-2xl font-black leading-snug text-[#18130e] md:text-4xl">
              争夺动态
              <br />
              时间线
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-[#6b5a48]">
              以天为单位梳理提名的发生、扩散与反转。谁在上升，谁在回落，一目了然。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <span className="rounded-full bg-[#b03a2e] px-3 py-1 text-xs font-semibold text-[#fbf7ef]">累计 47 条</span>
              <span className="rounded-full border border-[#d9cbb2] px-3 py-1 text-xs text-[#6b5a48]">更新于今日</span>
            </div>
          </div>

          {/* dense feed */}
          <div className="space-y-8">
            {DAYS.map((day) => (
              <div key={day.date}>
                <div className="flex items-center gap-3">
                  <span className="font-display text-sm font-bold text-[#8f2a20]">
                    {day.date}
                  </span>
                  <span className="h-px flex-1 bg-[#d9cbb2]"></span>
                </div>
                <div className="mt-3 space-y-3">
                  {day.entries.map((e) => (
                    <a
                      key={e.title}
                      href="#nomi"
                      className="block rounded-xl border border-[#e4d9c6] bg-[#fbf7ef] p-4 transition-colors hover:border-[#b03a2e] md:p-5"
                    >
                      <div className="flex flex-wrap items-center gap-2 text-xs">
                        <span className="rounded bg-[#e9dcc6] px-2 py-0.5 font-semibold text-[#6b4a2c]">
                          {e.tag}
                        </span>
                        <span className="font-semibold text-[#b03a2e]">{e.who}</span>
                        <span className="text-[#b8a98e]">{e.t}</span>
                      </div>
                      <h3 className="mt-2 text-base font-bold text-[#18130e] hover:text-[#8f2a20] md:text-lg">
                        {e.title}
                      </h3>
                      <p className="mt-1.5 text-sm leading-relaxed text-[#4a4036]">
                        {e.digest}
                      </p>
                      <div className="mt-3 flex items-center gap-1 text-xs text-[#8a6b4f]">
                        <i className="ri-arrow-right-line"></i> 追溯源头与转发路径
                      </div>
                    </a>
                  ))}
                </div>
              </div>
            ))}

            <div className="flex justify-center pt-2">
              <button
                type="button"
                className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full border border-[#b03a2e]/30 px-6 py-2.5 text-sm font-semibold text-[#8f2a20] transition-colors hover:bg-[#b03a2e] hover:text-[#fbf7ef]"
              >
                加载更早争夺记录
                <i className="ri-arrow-down-line"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}